import { render, staticRenderFns } from "./FlatGuestBox.vue?vue&type=template&id=8a5f080a&scoped=true&"
import script from "./FlatGuestBox.vue?vue&type=script&lang=js&"
export * from "./FlatGuestBox.vue?vue&type=script&lang=js&"
import style0 from "./FlatGuestBox.vue?vue&type=style&index=0&id=8a5f080a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5f080a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a5f080a')) {
      api.createRecord('8a5f080a', component.options)
    } else {
      api.reload('8a5f080a', component.options)
    }
    module.hot.accept("./FlatGuestBox.vue?vue&type=template&id=8a5f080a&scoped=true&", function () {
      api.rerender('8a5f080a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2fGZPWHHt7bT9/JS/comp/FlatGuestBox.vue"
export default component.exports